import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  root: {
    width: '100%',
  },
  currency: {
    color: theme.palette.labraText.description,
    lineHeight: '20px',
    fontSize: '14px',
  },
  price: {
    display: 'flex',
    alignItems: 'baseline',
    fontSize: '16px',
    lineHeight: '24px',
    justifyContent: 'end',
  },
  heading: {
    display: 'flex',
    alignItems: 'baseline',
    fontSize: '14px',
    lineHeight: '20px',
  },
  leftAlign: {
    display: 'flex',
    justifyContent: 'start',
  },
  amountInput: {
    width: '70%',
    '& input': {
      textAlign: 'end',
    },
  },
  alignRight: {
    textAlign: 'right',
  },
  tableHead: {
    fontSize: '12px',
    fontWeight: 400,
    color: theme.palette.labraText.description,
    backgroundColor: theme.palette.bgPrimary.main,
    boxShadow: `0px -1px 0px 0px ${theme.palette.dividerV2.main} inset`,
    borderBottom: 'none',
    '&.MuiTableCell-root': {
      lineHeight: '1.5rem',
    },
    '&.MuiTableCell-root .MuiFormControlLabel-root': {
      margin: `${theme.spacing(0)} !important`,
    },
  },
  editableAmount: {
    display: 'flex',
    justifyContent: 'end',
  },
}))
